// Phase 43.55 — Banner "+1 corsa rimborsata" mostrato nella Subscription page
// Soft verde/azzurro, dismissible. Persistente fino al click di chiusura.
// L'API marca server-side via POST /subscriptions/credits/seen (idempotente).
import { useState } from "react";
import { Gift, X } from "lucide-react";
import { api } from "@/lib/api";

export default function CreditRestoredBanner({ credits, onDismiss }) {
  const [dismissing, setDismissing] = useState(false);
  if (!credits || credits.length === 0) return null;

  const count = credits.length;
  const handleDismiss = async () => {
    if (dismissing) return;
    setDismissing(true);
    try {
      await api.post("/subscriptions/credits/seen", {
        order_ids: credits.map((c) => c.order_id).filter(Boolean),
      });
      if (onDismiss) onDismiss();
    } catch {
      // Anche se l'API fallisce, chiudiamo il banner client-side per UX
      if (onDismiss) onDismiss();
    }
  };

  return (
    <div
      data-testid="credit-restored-banner"
      className="relative overflow-hidden rounded-2xl border border-emerald-200 bg-gradient-to-br from-emerald-50 via-sky-50 to-emerald-50 px-4 sm:px-5 py-4 sm:py-4 shadow-sm"
    >
      <div className="flex items-start gap-3 pr-9">
        <div className="shrink-0 rounded-full bg-emerald-100 p-2 ring-1 ring-emerald-200">
          <Gift className="h-5 w-5 text-emerald-700" />
        </div>
        <div className="flex-1 min-w-0">
          <p className="font-display text-base sm:text-lg font-extrabold text-emerald-900 tracking-tight">
            {count === 1
              ? "Hai ricevuto +1 corsa rimborsata"
              : `Hai ricevuto +${count} corse rimborsate`}
          </p>
          <p className="text-xs sm:text-sm text-emerald-900/80 mt-0.5">
            {count === 1
              ? "Una corsa è stata riaccreditata al tuo piano. Puoi usarla quando vuoi questo mese."
              : `${count} corse sono state riaccreditate al tuo piano. Puoi usarle quando vuoi questo mese.`}
          </p>
        </div>
      </div>
      <button
        type="button"
        onClick={handleDismiss}
        disabled={dismissing}
        aria-label="Chiudi notifica"
        data-testid="credit-restored-banner-dismiss"
        className="absolute top-3 right-3 inline-flex items-center justify-center h-7 w-7 rounded-full text-emerald-700 hover:bg-emerald-100 transition disabled:opacity-50"
      >
        <X className="h-4 w-4" />
      </button>
    </div>
  );
}
